import './RestoreUsersTableButton.scss'
import {buttonColors} from "../Pickers/InputTheme";
import {Button} from "../Form/Button/Button";
import {useContext, useState} from "react";
import {GridReactContext} from "../../Utils/DataGridWrapper/GridContext";
import {I18nReactContext} from "../../contexts/I18nContext";
import {Modal} from "../Smart/Modal/Modal";
import RestoreIcon from '@mui/icons-material/Restore';
import {SA_restoreUsers} from "../../Services/SA_api";

/**
 * Button component for bulk restoring selected deleted users in SuperAdmin table
 * @param {Object} props - Component props
 * @param {Function} props.onSuccess - Callback function called after successful restore
 * @returns {JSX.Element} Restore button with confirmation modal
 */
export const RestoreUsersTableButton = ({onSuccess}) => {
    const {i18n} = useContext(I18nReactContext);
    const [isModalOpen, setIsModalOpen] = useState(false)
    const gridContext = useContext(GridReactContext)

    const onModalClose = () => {
        setIsModalOpen(false)
    }

    const onClick = () => {
        setIsModalOpen(true)
    }

    /**
     * Handles the restore action for selected users
     */
    const onConfirmRestore = async () => {
        const userIds = gridContext.selectionModel
        await SA_restoreUsers({userIds})
        setIsModalOpen(false)
        gridContext.setSelectionModelToContext([])
        gridContext.triggerTableRefresh()
        onSuccess && onSuccess()
    }

    // Get selected rows and check if any are deleted
    const selectedRows = gridContext.selectedRows || []
    // Check if all selected rows are deleted (deletedAt is not null for every row)
    const hasDeletedUsers = selectedRows.length > 0 && selectedRows.every(row => row.deletedAt !== null)
    const deletedUserCount = selectedRows.filter(row => row.deletedAt !== null).length

    return <div className="RestoreUsersTableButton">
        <Button
            disabled={!gridContext.selectionModel || gridContext.selectionModel.length === 0 || !hasDeletedUsers}
            color={buttonColors.GREEN}
            icon={<RestoreIcon/>}
            onClick={onClick}
            text={i18n.translate('SARestoreUser.restoreUsers')}
        />
        {isModalOpen ?
            <Modal open={isModalOpen} onClose={onModalClose}>
                <div className="restoreUsersModal modalWrapper">
                    <div className="modalTitle">
                        {i18n.translate('SARestoreUser.restoreUsersTitle')}
                    </div>
                    <div className="modalContent">
                        {i18n.translate('SARestoreUser.restoreUsersText', {context: {userCount: deletedUserCount}})}
                    </div>
                    <div className="modalFooter">
                        <Button
                            color={buttonColors.GREEN}
                            text={i18n.translate('SARestoreUser.restoreUsersConfirm')}
                            onClick={onConfirmRestore}
                        />
                        <Button
                            color={buttonColors.YELLOW}
                            text={i18n.translate('general.cancel')}
                            onClick={onModalClose}
                        />
                    </div>
                </div>
            </Modal>
        : ''}
    </div>
}
